import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { track } from '@lf/analytics-events';
import { useError } from '../contexts/ErrorContext';
import Profile from '../cards/settings/Profile';
import ProfileEdit from '../components/ProfileEdit';
import RecentActivities from '../cards/settings/RecentActivities';
import ProgressPage from './ProgressPage';
import StudyPlanAdd from '../cards/settings/StudyPlanAdd';
import SettingsHeader from '../cards/settings/SettingsHeader';
import SettingsTabNav from '../cards/settings/SettingsTabNav';
import MySharedPlans from '../cards/settings/MySharedPlans';
import yted, { api_post } from '@lf/api-client/lfApi';
import { postStudyPlan } from '@lf/api-client/lfApiStudyPlan';

const SettingsPage = ({ profile, setProfile, studyPlans, setStudyPlans, fetchStudyPlans, setSubscriptionAction }) => {
    const { setError } = useError();

    const navigate = useNavigate();

    const navigateToEditProfile = () => {
        navigate('edit');
    };

    const navigateToProgress = () => {
        navigate('progress');
    };

    const navigateToHistory = () => {
        navigate('history');
    };

    const navigateToProfile = () => {
        navigate('');
    };

    const handleCancel = () => {
        navigate('');
    };

    const handleLogout = async () => {
        await api_post('/auth/logout', { redirect: false }, setError);

        setStudyPlans([]);
        setSubscriptionAction({action: 'none'});
        setProfile(null);

        navigate('/');
    };

    const handleBack = () => {
        navigate('..');
    };

    const handleUpdateProfile = async (editedProfile) => {
        try {
            const response = await yted.put('/child/profile', editedProfile);
            if (response.status === 200) {
                setProfile(editedProfile);
            } else {
                console.error('Failed to update profile');
            }
        } catch (error) {
            console.error('Error updating profile:', error);
        }
        handleCancel();
    };

    const handleAddStudyPlan = async (studyPlan) => {
        track('study_plan_create_started', {
            goal_text_length: (studyPlan?.goal || '').length,
            child_id: profile?.user_profile_id || profile?.username,
            created_by_role: 'child',
        });
        const res = await postStudyPlan(profile.username, studyPlan, setError);
        if (res) {
            await fetchStudyPlans();
        }
        navigateToProfile();
    };

    return (
        <div>
            <Routes>
                <Route path="" element={
                    <div>
                        <SettingsHeader onBack={handleBack} onLogout={handleLogout} />
                        <SettingsTabNav activeTab="profile" onProfileClick={navigateToProfile} onProgressClick={navigateToProgress} onHistoryClick={navigateToHistory} />
                        <Profile
                            profile={profile}
                            setProfile={setProfile}
                            studyPlans={studyPlans}
                            fetchStudyPlans={fetchStudyPlans}
                            onEditProfile={navigateToEditProfile}
                            />
                    </div>
                } />
                <Route path="progress" element={
                    <div>
                        <SettingsHeader onBack={handleBack} onLogout={handleLogout} />
                        <SettingsTabNav activeTab="progress" onProfileClick={navigateToProfile} onProgressClick={navigateToProgress} onHistoryClick={navigateToHistory} />
                        <ProgressPage />
                    </div>
                } />
                <Route path="history" element={
                    <div className="text-left">
                        <SettingsHeader onBack={handleBack} onLogout={handleLogout} />
                        <SettingsTabNav activeTab="history" onProfileClick={navigateToProfile} onProgressClick={navigateToProgress} onHistoryClick={navigateToHistory} />

                        <h1 className="text-xl font-semibold mt-8">Recent activities</h1>

                        {
                            profile &&
                            <RecentActivities username={profile.username} />
                        }
                    </div>
                } />
                <Route path="edit" element={
                    <div className="mt-12">
                        <ProfileEdit profile={profile} onOk={handleUpdateProfile} onCancel={handleCancel} />
                    </div>
                } />
                <Route path="add_study_plan/*" element={
                    <div className="mt-12">
                        <div className="flex full-w mb-4">
                            <button className="text-gray-500 py-2 cursor-pointer hover:text-gray-700"
                                    onClick={() => navigate(-1)}>
                                ← Back
                            </button>
                        </div>

                        <StudyPlanAdd
                            username={profile?.username} onOk={handleAddStudyPlan} />
                    </div>
                } />
                <Route path="shares" element={
                    <div className="mt-12">
                        <MySharedPlans />
                    </div>
                } />
            </Routes>
        </div>
    );
};

export default SettingsPage;
